export const config = {
  apiUrl: "https://shivering-vikki-simoneg98-db24dea5.koyeb.app/api",
  webAppUrl: "https://ecard.effai.it",
  appStoreUrl: "https://apps.apple.com/it/app/ecard/id6756520426",
  playStoreUrl:
    "https://play.google.com/store/apps/details?id=com.simone.digitalcard&pcampaignid=web_share",
} as const;
